import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/money-currency-dollar-pay.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M12 2v20m5-17H9.5a3.5 3.5 0 1 0 0 7h5a3.5 3.5 0 1 1 0 7H6"
	}, null, -1)])]);
}
var money_currency_dollar_pay_default = { render };
//#endregion
export { money_currency_dollar_pay_default as default, render };

//# sourceMappingURL=money-currency-dollar-pay.svg.js.map